module.exports = __webpack_public_path__ + "static/img/background.47069d9d.png";